module.exports = __webpack_public_path__ + "img/exhibition-2.572c03f8.png";